import {Trans} from "../utils/i18n";
import React from "react";
import DeviceWidget from "../FormComponents/DeviceWidget/DeviceWidget";
import { hasProducts } from "./orderEntryEnfore";
import { validateEmailRegEx, validatePhoneNumber } from "../Shared/FormField";
import { isNil, uniqBy } from "lodash";
import PartMissingModal from "../Shared/PartMissingModal";
import { Alert } from "@mui/material";
import {addressConfigWithInvoice} from "./components/address";

export const shopDemoConfig = {
    sizes: {
        forth: 3,
        third: 4,
        half: 6,
        full: 12,
    },
    enableStepper: true,
    defaultValues: {
        productcategory: "all",
    },
    prepareSubmitData: (values) => {
        return {
            ...values,
            products: values.products
                // Only send the products that have an amount > 0
                .filter(product => !isNil(product.amount) && Number(product.amount) > 0)
                // Override the type to shop, so that the products can be handled correctly in the backend (e. g. price calculation)
                .map(product => ({
                    ...product,
                    type: "shop",
                })),
        };
    },
    heading: <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    groups: [
        {
            description: (
                <Trans i18nKey={"orderEntry.description"}>
                    Your device is not behaving as you expect?{" "}
                    <a
                        href={"https://b2x.com/"}
                        title={"B2X"}
                        target={"_blank"}
                    >
                        B2X
                    </a>{" "}
                    support you from here to provide a solution quickly. Please
                    complete the form below and we will get back to you to
                    resolve the situation.
                </Trans>
            ),
            fields: [
                {
                    size: "full",
                    component: "requesttypeselect",
                },
            ],
        },
        {
            heading: (
                <Trans i18nKey="orderEntry.productSelection">
                    Product selection
                </Trans>
            ),
            description: (
                <Trans i18nKey="orderEntry.productSelection.description"></Trans>
            ),
            id: "product_selection",
            fields: [
                {
                    size: "full",
                    component: "callback",
                    callback: (values) => (
                        <>
                            <h3 className={"mt-9"} style={{marginBottom: 0}}>
                            </h3>
                        </>
                    ),
                },
                {
                    size: "full",
                    component: "productcategoryselector",
                    showAll: false,
                    queryOptions: {
                        queryParameters: {
                            include: ["products"],
                            filter: {
                                "products.type": "unit",
                                is_for_sales: true,
                            },
                        }
                    }
                },
                {
                    size: "full",
                    component: "callback",
                    callback: (values) => (
                        <>
                            <h3 className={"mt-9"} style={{marginBottom: 0}}>
                                <Trans i18nKey={"shop.productSelect"}>
                                    Or select your model
                                </Trans>
                            </h3>
                        </>
                    ),
                    conditionFunction: (values) => {
                        return !!values.productcategory;
                    },
                },
                {
                    size: "full",
                    component: "productmodelgroupselector",
                    conditionFunction: (values) => {
                        return !!values.productcategory;
                    },
                },
                ({ dispatch, state, form, send, values, queryClient, pageProps }) => {
                    // TODO: Manage this in a cleaner way
                    const products = queryClient.getQueryData(["productModels",  {
                            filter: {
                                belongs_to_sales_productcategory: true,
                                type: "unit",
                                ...(values.productcategory !== "all" && {
                                    "productcategory.id": values.productcategory,
                                }),
                            },
                    }]) ?? [];

                    const isReady = products.length > 0;

                    // This is the parent product the materials belong to.
                    const parentProduct = products?.find(product => {
                        return product.model_group === values.model_group
                    });

                    return {
                        size: "full",
                        component: "productselector",
                        maxQuantity: pageProps?.maxQuantity ?? 20,
                        getProductCardProps: (product => ({
                            variant: "default",
                        })),
                        filterProduct: (product) => {
                            return parentProduct?.materials?.some(
                                (material) => material.id === product.id
                            );
                        },
                        queryOptions: {
                            queryParameters: {
                                filter: {
                                        model_group: values.model_group,
                                        belongs_to_sales_productcategory: true,
                                        type: "unit",
                                        ...(values.productcategory !== "all" && {
                                            "productcategory.id": values.productcategory,
                                        }),
                                        //variant: values.variant,
                                    },
                                include: [
                                    "materials",
                                    //"productVariants",
                                    //"productVariants.productVariantOption",
                                ].join(","),
                            },
                            onSuccess: (products = []) => {
                                dispatch({type: 'setSelectedCategory', value: products[0]});

                                // Always when we fetch products, we want to add the new products the our products array and initialize the quantities to 0
                                form.change(
                                    "products",
                                    uniqBy(
                                        [
                                            ...(values?.products ?? []),
                                            ...products
                                                ?.flatMap?.((product) => product.materials ?? [])
                                                ?.map((material) => ({
                                                    ...material,
                                                    amount: 0,
                                                })),
                                        ],
                                        "id"
                                    )
                                );
                            },
                            enabled: !!values.model_group && isReady,
                        },
                        title: (
                            <Trans i18nKey={"orderEntry.productSelect.heading"}>
                                Please select your product
                            </Trans>
                        ),
                        conditionFunction: (
                            values,
                            orderEntryState,
                            currentCountry
                        ) => {
                            return (
                                !!values.productcategory &&
                                !!values.model_group &&
                                isReady
                            );
                        },
                    }
                },
                // {
                //     size: "full",
                //     component: "selfrepairguides",
                //     conditionFunction: (
                //         values,
                //         orderEntryState,
                //         currentCountry
                //     ) => {
                //         return (
                //             !!values.productcategory &&
                //             !!values.model_group &&
                //             !!values.variant
                //         );
                //     },
                // },
            ],
            noNextButton: false,
        },
        {
            heading: (
                <Trans i18nKey="orderEntry.addressContact">
                    Contact information
                </Trans>
            ),
            description: (
                <Trans i18nKey="orderEntry.addressContact.description">
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat, sed diam voluptua.
                </Trans>
            ),
            id: "address",
            fields: [
                {
                    size: "full",
                    component: "callback",
                    callback: (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return (
                            <>
                                <DeviceWidget
                                    values={values}
                                    hideBadge={true}
                                />
                            </>
                        );
                    },
                },
                ({ values, form }) => ({
                    size: "full",
                    component: "shoppingcart",
                    products: values.products,
                    transportProductId: values.transport_product_id,
                    onChangeTransportProduct: (transportProduct) => form.change("transport_product_id", transportProduct.id),
                    onRemoveProduct: (product) => form.change("products", values.products?.filter(p => p?.id !== product.id) ?? []),
                    onUpdateProductQuantity: (productId, amount) => form.change("products", values.products?.map(p => p?.id === productId ? { ...p, amount } : p) ?? []),
                    className: "b2x-shadow-md bg-white p-8 mt-4",
                }),
                {
                    size: "full",
                    component: "callback",
                    callback: (values) => (
                        <>
                            <h2>
                                <Trans i18nKey={"orderEntry.contactInfo"}>
                                    Contact info
                                </Trans>
                            </h2>
                        </>
                    ),
                },
                ...addressConfigWithInvoice,
            ],
            conditionFunction: (values, orderEntryState) => {
                return hasProducts(values.products);
            },
        },
        {
            heading: (
                <Trans i18nKey="common.checkout">Confirmation / Summary</Trans>
            ),
            description: (
                <Trans i18nKey="orderEntry.termsandconditions.description"></Trans>
            ),
            id: "terms",
            fields: [
                {
                    size: "full",
                    component: "callback",
                    callback: (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return (
                            <>
                                <DeviceWidget
                                    values={values}
                                    hideBadge={true}
                                />
                            </>
                        );
                    },
                },
                {
                    size: "full",
                    component: "callback",
                    callback: (values) => (
                        <>
                            <h2 style={{marginBottom: 0}}>
                                <Trans
                                    i18nKey={"orderEntry.verifyAccountToPay"}
                                >
                                    Verify your information
                                </Trans>
                            </h2>
                        </>
                    ),
                },
                {
                    size: "full",
                    component: "verify_phone_number",
                },
                {
                    name: "terms_of_service",
                    label: (
                        <Trans i18nKey="orderEntry.termsandconditions.label">
                            I have read and accept the <a
                            href={route("shop.termsandconditions")}
                            target={"_blank"}
                        >
                            Terms & Conditions
                        </a> and the <a href={route("privacy")} target={"_blank"}>
                            Privacy Statement
                        </a>
                        </Trans>
                    ),
                    size: "full",
                    type: "checkbox",
                    required: true,
                },
            ],
            conditionFunction: (values, orderEntryState) => {
                const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                const validAddress = validName && values.housenumber && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);
                const validInvoiceAddress = values.deviating_invoice_address == true ? (values?.invoice_private_or_company === "private" ? (values?.invoice_first_name && values?.invoice_last_name) : values?.invoice_name) && values.invoice_city && values.invoice_street && values.invoice_zip && values.invoice_country_id : true;
                const validTransportProduct = !!values.transport_product_id;

                return (
                    validAddress &&
                    validInvoiceAddress &&
                    hasProducts(values.products) &&
                    validTransportProduct
                );
            },
        },
    ],
    actions: [
        {
            fields: [
                {
                    text: <Trans i18nKey="orderEntry.send">Send</Trans>,
                    size: "half",
                    component: "button",
                    action: "next",
                    color: "secondary",
                    conditionFunction: (values, orderEntryState) => {
                        const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                        const validAddress = validName && values.housenumber && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                        return (
                            values.terms_of_service &&
                            orderEntryState?.verificationCodeResponse &&
                            !!validAddress &&
                            hasProducts(values.products)
                        );
                    },
                },
            ],
        },
    ],
};
